import * as rxjs from "rxjs";
import { useEffect, useMemo, useRef, useState } from "preact/hooks";

export function useObservable<T>(source$: rxjs.Observable<T>, initial: T): T {
  const [value, setValue] = useState<T>(initial);
  useEffect(() => {
    const sub = source$.subscribe((next) => setValue(() => next));
    return () => sub.unsubscribe();
  }, [source$]);
  return value;
}

export interface Selectable<S> {
  state: S;
  select$<T>(selector: (state: S) => T, isEqual?: (a: T, b: T) => boolean): rxjs.Observable<T>;
}

export function useSelect<S, T>(
  source: Selectable<S>,
  selector: (state: S) => T,
  isEqual: (a: T, b: T) => boolean = Object.is,
): T {
  const latest = useRef(selector);
  latest.current = selector;
  const select$ = useMemo(
    () => source.select$((state) => latest.current(state), isEqual),
    [source],
  );
  return useObservable(select$, selector(source.state));
}
